// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6578) return "static/chunks/6578-2978b2d27b2dd3f9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "724dd7796259f623" + ".js";
};